import { createLogger } from '../../utils/Logger';

import IdentityType from './constants/IdentityType';
import AuthToken from './AuthToken';

export interface Identity<T extends IdentityType = IdentityType> {
    credential: string;
    identityType: T;
    principal?: string;
}

export interface IdentityRequest {
    credential?: string;
    identityType: IdentityType;
    misc?: Record<string, any>;
    principal?: string | null;
}

export interface IdentityResponse {
    id: string;
    identityType: IdentityType;
}

export interface EmailIdentity extends Identity<IdentityType.EMAIL> {
    principal: string;
}
export interface InternalIdentity extends Identity<IdentityType._INTERNAL> {
    principal: string;
}

if (process.env.NODE_ENV !== 'production') {
    const logger = createLogger('AuthToken', '#FC5933');
    AuthToken.subscribe(value => logger.log('', AuthToken, value));
}

export { default as Apps } from './constants/Apps';
export { default as Authorization } from './constants/Authorization';
export { default as BaseURL } from './constants/BaseURL';
export { default as EmailStatus } from './constants/EmailStatus';
export { default as IdentityType } from './constants/IdentityType';
